import axios from "fetch-api/fetch-api";

export function getProfileByWidth(width: number) {
  return axios.get<string[]>("/get-profiles", {
    params: {
      width,
    },
  });
}
